class MerchantStorage {
  public path?: string;
}

export const merchantStorage = new MerchantStorage();
